import { IonContent, IonImg } from "@ionic/react";
// @ts-ignore
//import ReactCountdownClock from "react-countdown-clock";
import { useEffect, useState } from "react";

interface Props {
  setShowModal3: Function
}

const AssessmentCounter: React.FC<Props> = ({ setShowModal3 }) => {

  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds => seconds - 1);
    }, 500);
    return () => clearInterval(interval);
  }, []);


  if (seconds < 0) {
    setShowModal3(false);
  }
  return (
    <IonContent placeholder={undefined}>
      <div className="assessmet-complete-wrap counter-center-sec">
          <div className="assessmnet-text-wrap">
            <h2>Go!</h2>
            <svg width="306" height="306" viewBox="0 0 306 306" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M152.999 0.455078C68.7508 0.455078 0.454163 68.7517 0.454163 153C0.454163 237.248 68.7508 305.545 152.999 305.545C237.247 305.545 305.544 237.248 305.544 153C305.544 68.7517 237.247 0.455078 152.999 0.455078Z" fill="#43BA73" />
              <path d="M198.763 122.491L137.745 183.509L107.236 153" stroke="white" strokeWidth="30.509" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
      </div>
    </IonContent>
  );
}
export default AssessmentCounter;
